<template>
  <result @btn-update="handleUpdate"/>
</template>
<script>
import result from "../result";
export default {
  components: { result },
  mounted() {
    this.handleUpdate();
  },
  methods: {
    handleUpdate() {
      //处理个性化样式
      this.$nextTick(x => {
        let dom = document.querySelector("span[class~='result-btn-download']");
        if (dom) {
          dom.classList.add("result-btn-mx");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.result-btn-mx {
  color: #fff;
  background: linear-gradient(45deg, #ff5b1d, #ff7f41);
}
</style>


